<div class="tw-w-full tw-h-full tw-bg-surface-20 tw-relative">
    <div class="keen-slider keen-slider--vertical" #sliderRef>
        <ng-container *ngIf="!isloading">
            <div class="keen-slider__slide" *ngFor="let item of allNews; let idx = index">
                <div class="tw-min-h-screen tw-flex tw-flex-col tw-gap-y-2.5">
                    <div
                        class="tw-flex tw-flex-col tw-items-start tw-flex-1 tw-h-screen tw-max-h-[calc(100vh-70px)] tw-overflow-y-auto">
                        <div class="tw-flex tw-flex-row tw-w-full tw-justify-center tw-bg-primary-900">
                            <img src="{{baseUrl}}{{item.images}}" class="tw-max-h-[250px]" [alt]="item.title">
                        </div>
                        <div class="tw-flex tw-w-full tw-flex-col tw-gap-y-4 tw-p-6 tw-relative">
                            <app-social-share [baseUrl]="baseUrl" [contentType]="'News'" iconColor="#1a1b20"
                                [shareUrl]="'/market-news/'+item.id" [image]="item.images" [subject]="item.title"
                                class="tw-absolute tw-top-2.5 tw-right-2.5"></app-social-share>
                            <div class="tw-flex tw-flex-row tw-flex-wrap tw-items-center tw-gap-2.5">
                                <span
                                    class="tw-bg-primary-900 tw-text-secondary-10 tw-text-xs tw-rounded tw-pt-1.5 tw-pb-1 tw-px-2.5"
                                    *ngFor="let topic of item.topic">{{topic.title}}</span>
                            </div>
                            <p class="tw-text-color-1 tw-text-p1 md:tw-text-p1-md tw-font-bold">{{item.title}}</p>
                            <div class="tw-flex tw-flex-row tw-items-center tw-w-full tw-justify-between tw-gap-x-8">
                                <span class="tw-text-color-1 tw-text-sm">{{item.creditTo}}</span>
                                <span class="tw-text-color-1 tw-text-sm">{{item.createdAt|date:'medium'}}</span>
                            </div>
                            <p class="tw-text-color-1">{{item.desc}}</p>
                        </div>
                    </div>
                    <button type="button"
                        class="tw-btn tw-w-full !tw-bg-primary-900 !tw-rounded-none !tw-text-surface-20 tw-flex tw-items-center tw-justify-between"
                        (click)="openNews(item)">Tap to read more
                        <common-icons iconName="arrow-small" class="tw-w-8 tw-h-8 tw-rotate-[-90deg]"></common-icons>
                    </button>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="tw-flex tw-py-20 tw-min-w-[280px] tw-w-full tw-items-center tw-justify-center" *ngIf="isloading">
        <app-loader></app-loader>
    </div>
    <button type="button" class="tw-btn !tw-p-0 tw-absolute tw-top-1/2 tw-left-[-40px] md:tw-hidden" *ngIf="slider"
        [disabled]="currentSlide === 0" (click)="slider.prev()" aria-label="Previous Slide">
        <common-icons iconName="arrow-small" class="tw-w-12 tw-h-12 tw-rotate-[90deg]" aria-hidden="true"
            [class]="currentSlide === 0 ? 'tw-text-surface-100 tw-opacity-50':'tw-text-surface-10'"></common-icons>
    </button>
    <button type="button" class="tw-btn !tw-p-0 tw-absolute tw-top-1/2 tw-right-[-40px] md:tw-hidden" *ngIf="slider"
        [disabled]="this.totalCount === currentSlide" (click)="slider.next()" aria-label="Next Slide">
        <common-icons iconName="arrow-small" class="tw-w-12 tw-h-12 tw-rotate-[-90deg]" aria-hidden="true"
            [class]="this.totalCount === currentSlide ? 'tw-text-surface-100 tw-opacity-50':'tw-text-surface-10'"></common-icons>
    </button>
    <button type="button" class="tw-btn !tw-p-0 tw-absolute tw-top-[12px] tw-right-[-40px] md:tw-right-0"
        (click)="close()" aria-label="Close">
        <common-icons iconName="x" class="tw-text-surface-20 tw-w-6 tw-h-6" aria-hidden="true"></common-icons>
    </button>
</div>